import { Context } from '@vendasta/automata';
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const AUTOMATION_CONTEXT_INJECTION_TOKEN = 'AUTOMATION_CONTEXT';
export const AUTOMATION_NAMESPACE_INJECTION_TOKEN$ = 'AUTOMATION_NAMESPACE';
export const AUTOMATION_PARTNER_ID_INJECTION_TOKEN$ = 'AUTOMATION_PARTNER_ID';
export const AUTOMATION_MARKET_ID_INJECTION_TOKEN$ = 'AUTOMATION_MARKET_ID';

export const AUTOMATION_VARIABLE_MENU_DIALOG = 'AUTOMATION_VARIABLE_MENU_DIALOG';

export interface VBCEntryInfo {
  url: string;
  name: string;
}

export interface BusinessCenterService {
  getVBCEntryUrl(accountGroupId?: string, page?: string): Observable<VBCEntryInfo>;
}

export const AUTOMATION_BUSINESS_ENTRY_URL_SERVICE = new InjectionToken<BusinessCenterService>(
  '[Automations]: We need the business entry url for sending notifications to customers',
);

export interface AccessService {
  hasAccessToFeature(feature: string): Observable<boolean>;

  hasAccessToFeatures(features: string[]): Observable<boolean>;
}

export const AUTOMATIONS_ACCESS_SERVICE = new InjectionToken<AccessService>(
  '[Automations - Access Service]: If the user has access to subscription features',
);

export const AUTOMATION_IS_USER_SUPERADMIN$ = new InjectionToken<Observable<boolean>>(
  '[Automations]: If the user is a superadmin',
);

export const AUTOMATION_DEFAULT_CURRENCY_CODE = new InjectionToken<Observable<string>>(
  '[Automations]: The default currency code to use. i.e USD, CAD, etc',
);

export interface Market {
  name: string;
  partner_id: string;
  market_id: string;
}

export interface MarketsService {
  markets$: Observable<Market[]>;
}

export const AUTOMATIONS_MARKETS_SERVICE = new InjectionToken<MarketsService>(
  '[Automations Market Service]: Markets are required for the market filter, this should only be provided in PCC but we need to segment our task definition providing first',
);

export const AUTOMATIONS_ROUTE_PREFIX$ = new InjectionToken<Observable<string>>(
  '[Automations - Route prefix service]: If the user has access to subscription features',
);

export interface Tab {
  path: string;
  label: string;
}

export interface ContextConfig {
  systemAutomations: {
    titleTranslationKey: string;
  };
  showZendeskLinkOnEmptyPage: boolean;
  hideUserFilterOnAutomationsTable: boolean;
  whitelabel: boolean;
  viewAutomationsRoute: string;
}

const PartnerConfigContext: ContextConfig = {
  systemAutomations: {
    titleTranslationKey: 'AUTOMATIONS.COMMON.SYSTEM_AUTOMATIONS',
  },
  showZendeskLinkOnEmptyPage: true,
  hideUserFilterOnAutomationsTable: false,
  whitelabel: false,
  viewAutomationsRoute: '/automations',
};

const SMBConfigContext: ContextConfig = {
  systemAutomations: {
    titleTranslationKey: 'AUTOMATIONS.COMMON.AUTOMATIONS',
  },
  showZendeskLinkOnEmptyPage: false,
  hideUserFilterOnAutomationsTable: true, // SMBs aren't currently exposed to all the users that have access to their agid so hide this for now
  whitelabel: true,
  viewAutomationsRoute: '/automations/all',
};

export const ContextConfigMap = {
  [Context.AUTOMATION_CONTEXT_UNSET]: null,
  [Context.AUTOMATION_CONTEXT_SMB]: SMBConfigContext,
  [Context.AUTOMATION_CONTEXT_PARTNER]: PartnerConfigContext,
};
